import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import emptyL from "../Lazy/emptyL.js";
export default function toIter(iterable) {
  return iterable && _getIteratorMethod(iterable) ? _getIterator(iterable) : emptyL();
}